import HTTP from '@/plugins/http';
import validationStatusCode from '@/resources/validation_status_code';

const getChoices = async () => validationStatusCode(
  await HTTP.get('/utils/choices/')
);

export default {
  getChoices,
};
